import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import incompleteIcon from '../../assets/icons/incomplete-icon.svg';
import completeIcon from '../../assets/icons/complete-icon.svg';
import navNext from '../../assets/icons/nav-next.svg';
import {
  NavigationTitle,
  NavigationContainer,
  NavigationIcon,
  NavigationItem as NavigationItemWrapper,
  NavigationStatusIcon,
  NavigationTexts,
  NavigationStatusText,
  NextArrow,
  NavigationDescription,
} from './styled';

type NavigationItemProps = {
  title: string;
  completed?: boolean;
  path: string | null;
  statusText?: string;
  icon?: string;
  isStatusBoxVisible?: boolean;
  description?: string;
  maxWidth?: string;
};
const NavigationItem = ({
  title,
  icon,
  completed,
  statusText,
  path,
  isStatusBoxVisible = true,
  description,
  maxWidth,
}: NavigationItemProps) => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const statusIcon = completed ? completeIcon : incompleteIcon;
  const defaultStatusText = completed ? t('completed') : t('incomplete');
  const displayedStatus = statusText ? t(statusText) : defaultStatusText;

  const goToView = React.useCallback(() => {
    if (path) navigate(`../${path}`);
  }, [navigate, path]);

  return (
    <NavigationContainer maxWidth={maxWidth} className="nav-item">
      <NavigationItemWrapper isClicked={!!path} onClick={goToView}>
        <NavigationIcon
          width={40}
          height={40}
          src={icon}
          alt="Navigation Icon"
          className="nav-item__icon"
        />
        <NavigationTexts className="nav-item__content">
          <NavigationTitle className="nav-item__title">{title}</NavigationTitle>
          {isStatusBoxVisible && (
            <NavigationStatusText completed={!!completed} className="nav-item__status">
              <NavigationStatusIcon
                width={14}
                height={14}
                src={statusIcon}
                alt="Status Icon"
              />
              {displayedStatus}
            </NavigationStatusText>
          )}
          {description && (
            <NavigationDescription className="nav-item__description">
              {description}
            </NavigationDescription>
          )}
        </NavigationTexts>
        <NextArrow src={navNext} alt="Next Icon" width={10} height={21} />
      </NavigationItemWrapper>
    </NavigationContainer>
  );
};

export {NavigationItem};
